export const USERNAME_REGEX = /^[A-Za-z0-9._-]{1,50}$/;

export const SALUTATIONS = [
  { value: "male", translationKey: "accountSetup.salutation.options.male" },
  { value: "female", translationKey: "accountSetup.salutation.options.female" },
  { value: "diverse", translationKey: "accountSetup.salutation.options.diverse" },
] as const;

export type SalutationValue = (typeof SALUTATIONS)[number]["value"];
